<aside class="dashboard-events-sidebar" style="height: calc(100vh - 115px)">
  <header class="dashboard-events-sidebar-header">
    <div class="row-inline">
      <img src="assets/svg/generate-reports.svg" class="mr-5" width="25" alt="" />
      <h2 class="no-mg">{{ 'REPORTS.TITLE.GENERATE_REPORT' | translate }}</h2>
    </div>
  </header>

  <section class="dashboard-events-sidebar-section" style="margin: 20px 18px 14px">
    <form [formGroup]="form" (ngSubmit)="onGenerate($event)">
      <div class="generate-report">
        <div class="content">
          <div class="cell form-group">
            <div class="box">
              <app-yabi-input
                type="dropdown"
                [form]="form"
                (onChange)="reportTypeChange.emit($event)"
                wrapperClass="no-mg"
                placeholder="REPORTS.FORMS.PLACEHOLDERS.REPORT_TYPE"
                [listConfig]="reportTypesList"
                formControlNameInput="report_type"
                id="report_type"
              ></app-yabi-input>
            </div>
          </div>
          <ng-content select="[other-header]"></ng-content>
          <ng-content select="[content]"></ng-content>
        </div>
        <div class="cell end-of-sidebar">
          <button type="submit" [disabled]="form.invalid" class="btn btn-primary fw-100">
            <i aria-hidden="true" class="pi pi-file"></i>
            {{ 'REPORTS.TITLE.GENERATE_REPORT' | translate }}
          </button>
        </div>
      </div>
    </form>
  </section>
</aside>
